var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCoinTail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddn_3379_6097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2764 5.77441C19.5491 6.21847 19.7875 6.68552 19.9893 7.17188L19.6162 7.32715C19.807 7.78726 19.9631 8.26583 20.0811 8.75879L20.4727 8.66406C20.5931 9.1674 20.6747 9.68514 20.7158 10.2148L20.3154 10.2461C20.3347 10.4948 20.3447 10.7462 20.3447 11C20.3447 11.2538 20.3347 11.5052 20.3154 11.7539L20.7158 11.7842C20.6747 12.3139 20.5931 12.8316 20.4727 13.335L20.0811 13.2412C19.9631 13.7342 19.807 14.2127 19.6162 14.6729L19.9893 14.8271C19.7876 15.3135 19.5491 15.7805 19.2764 16.2246L18.9316 16.0137C18.6681 16.4428 18.3716 16.8494 18.0459 17.2305L18.3525 17.4922C18.0119 17.8907 17.6407 18.2619 17.2422 18.6025L16.9805 18.2959C16.5994 18.6216 16.1928 18.9181 15.7637 19.1816L15.9746 19.5264C15.5305 19.7991 15.0635 20.0376 14.5771 20.2393L14.4229 19.8662C13.9627 20.057 13.4842 20.2131 12.9912 20.3311L13.085 20.7227C12.5816 20.8431 12.0639 20.9247 11.5342 20.9658L11.5039 20.5654C11.2552 20.5847 11.0038 20.5947 10.75 20.5947C10.4962 20.5947 10.2448 20.5847 9.99609 20.5654L9.96484 20.9658C9.43514 20.9247 8.9174 20.8431 8.41406 20.7227L8.50879 20.3311C8.01583 20.2131 7.53726 20.057 7.07715 19.8662L6.92188 20.2393C6.43552 20.0375 5.96847 19.7991 5.52441 19.5264L5.73633 19.1816C5.30725 18.9181 4.90057 18.6216 4.51953 18.2959L4.25684 18.6025C3.85834 18.2619 3.4871 17.8907 3.14648 17.4922L3.4541 17.2305C3.12838 16.8494 2.83188 16.4428 2.56836 16.0137L2.22266 16.2246C1.95 15.7805 1.71144 15.3135 1.50977 14.8271L1.88379 14.6729C1.69299 14.2127 1.5369 13.7342 1.41895 13.2412L1.02637 13.335C0.905947 12.8317 0.824301 12.3138 0.783203 11.7842L1.18457 11.7539C1.16525 11.5052 1.15527 11.2538 1.15527 11C1.15527 10.7462 1.16525 10.4948 1.18457 10.2461L0.783203 10.2148C0.824351 9.68519 0.905901 9.16736 1.02637 8.66406L1.41895 8.75879C1.5369 8.26583 1.69299 7.78726 1.88379 7.32715L1.50977 7.17188C1.70535 6.7003 1.93483 6.24637 2.19727 5.81445L2.22266 5.77441L2.56836 5.98633C2.83188 5.55725 3.12838 5.15057 3.4541 4.76953L3.14648 4.50684C3.48711 4.10834 3.85834 3.73711 4.25684 3.39648L4.51953 3.7041C4.90057 3.37838 5.30725 3.08188 5.73633 2.81836L5.52441 2.47266C5.96845 2.19997 6.43555 1.96147 6.92188 1.75977L7.07715 2.13379C7.53726 1.94299 8.01583 1.7869 8.50879 1.66895L8.41406 1.27637C8.91736 1.1559 9.43519 1.07435 9.96484 1.0332L9.99609 1.43457C10.2448 1.41525 10.4962 1.40527 10.75 1.40527C11.0038 1.40527 11.2552 1.41525 11.5039 1.43457L11.5342 1.0332C12.0638 1.0743 12.5817 1.15595 13.085 1.27637L12.9912 1.66895C13.4842 1.7869 13.9627 1.94299 14.4229 2.13379L14.5771 1.75977C15.0635 1.96144 15.5305 2.2 15.9746 2.47266L15.7637 2.81836C16.1928 3.08188 16.5994 3.37838 16.9805 3.7041L17.2422 3.39648C17.6407 3.7371 18.0119 4.10834 18.3525 4.50684L18.0459 4.76953C18.3716 5.15057 18.6681 5.55725 18.9316 5.98633L19.2764 5.77441Z",
    stroke: "#005754",
    strokeWidth: 0.811359,
    strokeDasharray: "1.62 1.62",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_iin_3379_6097)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.7489,
    cy: 10.9989,
    r: 9.18864,
    transform: "rotate(180 10.7489 10.9989)",
    fill: "#E1FAFA"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_in_3379_6097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.95477 12.5139H6.08594V9.81366H10.929V12.5139H15.4218V9.47656",
    stroke: "#005754",
    strokeWidth: 0.671664
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddn_3379_6097",
    x: 0.351082,
    y: 0.864773,
    width: 20.7573,
    height: 20.7573,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.0540906,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3379_6097"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.020284,
    dy: 0.243408
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.162272
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3379_6097"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.0540906,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_3379_6097"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.020284,
    dy: 0.0811359
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.040568
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3379_6097",
    result: "effect2_dropShadow_3379_6097"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "49.29998779296875 49.29998779296875",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 2402
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.08)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect3_noise_3379_6097"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  })), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "effect3_noise_3379_6097",
    in2: "effect2_dropShadow_3379_6097",
    result: "effect3_noise_3379_6097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_iin_3379_6097",
    x: 1.55859,
    y: 1.65023,
    width: 18.4398,
    height: 18.7807,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.0608519,
    dy: 0.243408
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.243408
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3379_6097"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.162272
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.243408
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_3379_6097",
    result: "effect2_innerShadow_3379_6097"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "49.29998779296875 49.29998779296875",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 1911
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "effect2_innerShadow_3379_6097",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(225, 250, 250, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect3_noise_3379_6097"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "effect2_innerShadow_3379_6097"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_in_3379_6097",
    x: 5.75,
    y: 9.47656,
    width: 10.0078,
    height: 3.41557,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.040568
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0882353
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3379_6097"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "49.29998779296875 49.29998779296875",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 1911
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "effect1_innerShadow_3379_6097",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(179, 40, 33, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect2_noise_3379_6097"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "effect1_innerShadow_3379_6097"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCoinTail);
export default __webpack_public_path__ + "static/media/green-coin-tail.e35af0009ef88e243dc57e9ea3f0c7f5.svg";
export { ForwardRef as ReactComponent };